import { Button } from "@components/Button";
import { OnboardingLayout } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H2 } from "@components/Typography";
import { Routes } from "@ctypes";
import { useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";
import { CheckMark } from "@routes/AllocateFundsRoute/AllocateFundsSuccessModal/CheckMark";
import { useNavigate } from "react-router-dom";
import { styles } from "./styles";

export const ResetPasswordSuccessRoute = () => {
  const { theme } = useTheme();

  const navigate = useNavigate();

  return (
    <OnboardingLayout>
      <Spacing size={SpacingSizes.XL} />

      <CheckMark background={theme.button.background.secondary} />
      <Spacing size={SpacingSizes.M} />

      <H2 style={styles.text}>{i18n.t(Translations.ResetPasswordSuccessRouteTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <Body style={styles.text}>{i18n.t(Translations.ResetPasswordSuccessRouteSubtitle)}</Body>
      <Spacing size={SpacingSizes.M} />

      <Button
        title={i18n.t(Translations.ResetPasswordSuccessRoutePrimaryCTA)}
        onClick={() => {
          navigate(Routes.Default, { replace: true });
        }}
      />
      <Spacing size={SpacingSizes.XL} />
    </OnboardingLayout>
  );
};
